import Service from "@/utils/api/service";
import { mapState } from "vuex";

export default {
  name: "ListEWarrantyCard",
  data() {
    return {
      isFetching: true,
      isCreating: false,
      body: {
        termAndConditionEn: "",
        termAndConditionKh: "",
        attachment: "",
      },
      loading: {
        isCreating: false,
        isSearching: false,
      },
      customToolbars: [
        [{ header: [1, 2, 3, false] }], // Heading 1, 2, 3, normal text
        ["bold", "italic", "underline"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        ["link"],
        [{ color: [] }, { background: [] }], // text color + fill color
        // [{ size: ["small", false, "large", "huge"] }], // ✅ font size dropdown
      ],
      attachment: "",
      tempAttachment: "",
    };
  },
  components: {},
  computed: {
    ...mapState(["permissions"]),
  },
  async created() {
    await this.getList();
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0] || null;

      if (!file && this.attachment) {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = null;
        }

        this.body.attachment = this.attachment?.name || "";
        return;
      }

      // When file is selected
      this.attachment = file;
      this.body.attachment = file.name;
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    async getList() {
      await Service.listEWarrantyCard().then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getList();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          if (response) {
            this.body = {
              termAndConditionEn: response?.termAndConditionEn || "",
              termAndConditionKh: response?.termAndConditionKh || "",
              attachment: response?.attachment || "",
            };
            this.tempAttachment = response?.attachment || "";
          }
        }

        this.isFetching = false;
      });
    },

    fullPath(path) {
      return `${process.env.VUE_APP_BASE_URL_IMAGE_CLIENT}${path}`;
    },

    deleteAttachment() {
      this.body.attachment = "";
      this.attachment = "";

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null; // reset input
      }
    },

    async uploadFile(file) {
      this.isCreating = true;

      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const params = "?folder=other&type=document";

        try {
          const response = await Service.uploadMediaFile(params, formData);

          if (response?.data) {
            this.body.attachment = response?.data?.url || "Error File";

            this.attachment = "";
            this.onConfirm();
          } else {
            this.$toasted.show("Attachment upload failed!");
            this.isCreating = false;
          }
        } catch (error) {
          this.$toasted.show("Attachment upload error!");
          this.isCreating = false;
        }
      } else {
        this.onConfirm();
      }
    },

    onSubmit() {
      this.uploadFile(this.attachment);
      // let validatedMessage = this.validateBody();
      // console.log(this.body);

      // if (validatedMessage == "ok") {
      //   this.isCreating = true;

      //   this.onConfirm();
      // } else {
      //   this.$toasted.show(validatedMessage);
      // }
    },

    validateBody() {
      return "ok";
    },

    onConfirm() {
      if (this.body?.termAndConditionEn.trim() === "<p><br></p>") {
        this.body.termAndConditionEn = ""; // or "Coming soon"
      }

      if (this.body?.termAndConditionKh.trim() === "<p><br></p>") {
        this.body.termAndConditionKh = ""; // or "Coming soon"
      }

      Service.createEWarrantyCard(this.body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.onConfirm();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isCreating = false;
          this.$toasted.show("E-Warranty Card has been updated.");
          // this.isFetching = true;
          this.getList();
        }
      });
    },
  },
};
